const environment = process.env.REACT_APP_ENVIRONMENT === "Development" ?? "Production";

export const baseUrl =
  environment
    ? process.env.REACT_APP_TEST_Api_URL
    : process.env.REACT_APP_LIVE_Api_URL
export const baseUrl2 =
    environment
    ? process.env.REACT_APP_TEST_BaseApi_URL
    : process.env.REACT_APP_LIVE_BaseApi_URL

export const verifyURL = 
        environment
        ? process.env.REACT_APP_TEST_Verify_URL
        : process.env.REACT_APP_LIVE_Verify_URL
